import store from "@/store";
import swal from "sweetalert";

async function setZipCode(zipCode, city, arrayZipCode) {
  let response;
  if (zipCode != null && zipCode != "") {
    response = await store.dispatch("standardize/standardizeZip", zipCode);
  }
  if (response.status == 200) {
    if (
      response.data[0][1] == "Not Acceptable" ||
      response.data[0][1] == null
    ) {
      return await swal({
        title: "Warning!",
        text: `It seems that ${zipCode} doesn't exist. Do you want to add this zip code anyway?`,
        icon: "warning",
        buttons: true,
        dangerMode: false
      }).then(willDelete => {
        if (!willDelete) {
          zipCode = null;
          return {
            exists: false,
            cancel: true,
            arrayZipCode
          };
        } else {
          if (!arrayZipCode.includes(zipCode)) {
            arrayZipCode.push(zipCode);
          }
          return {
            exists: false,
            cancel: false,
            arrayZipCode
          };
        }
      });
    } else {
      if (!arrayZipCode.includes(zipCode)) {
        arrayZipCode.push(zipCode);
      }
      let city_selected = response.data[0][1];
      if (!city.includes(city_selected)) {
        city.push(response.data[0][1]);
      }
      return {
        exists: true,
        arrayZipCode,
        city,
        city_selected,
        zip_code_response: response.data[0][0],
        country_response: response?.data[0][2]
      };
    }
  }
}

async function setCity(city, zipCode, arrayCity) {
  let response;
  if (city != null && city != "") {
    response = await store.dispatch("standardize/standardizeCity", city);
  }
  if (response.status == 200) {
    if (
      response.data[0][0] == "Not Acceptable" ||
      response.data[0][0] == null
    ) {
      return await swal({
        title: "Warning!",
        text: `It seems that ${city} doesn't exist. Do you want to add this city anyway?`,
        icon: "warning",
        buttons: true,
        dangerMode: false
      }).then(willDelete => {
        if (!willDelete) {
          city = null;
          return {
            exists: false,
            cancel: true,
            arrayCity
          };
        } else {
          if (!arrayCity.includes(city)) {
            arrayCity.push(city);
          }
          return {
            exists: false,
            cancel: false,
            arrayCity
          };
        }
      });
    } else {
      if (!arrayCity.includes(response.data[0][1])) {
        arrayCity.push(response.data[0][1]);
      }
      let zipCodeSelected = response.data[0][0];
      let citySelected = response.data[0][1];
      if (!zipCode.includes(zipCodeSelected)) {
        zipCode.push(response.data[0][0]);
      }
      return {
        exists: true,
        arrayCity,
        zipCode,
        zipCodeSelected,
        citySelected
      };
    }
  }
}

function removePointerEvents(id) {
  document.getElementById(id).style.pointerEvents = "none";
}

export { setZipCode, setCity, removePointerEvents };
